import { graphHooks } from '@tunasong/graph-lib/react'
import { profilesApi } from '@tunasong/redux'
import type { EntityType, EventCommands } from '@tunasong/schemas'
import invariant from 'tiny-invariant'
import { mergeProfileEventCommands, readProfileEventCommands } from './profile-event-commands.js'

export const useProfileCommands = (type?: EntityType) => {
  const { profile } = graphHooks.useProfile()
  const [updateProfile] = profilesApi.useUpdateProfileMutation()

  const config = profile?.config
  const eventCommands = type ? readProfileEventCommands(config, type) : {}

  const onChange = (newCommands: EventCommands) => {
    invariant(type && profile)
    void updateProfile({
      id: profile.id,
      profile: {
        config: mergeProfileEventCommands(config, type, newCommands),
      },
    })
  }

  return { eventCommands, onChange }
}
